import React, {useEffect, useState} from 'react';
import {Pagination} from "antd";
import RoomsTable from "../../components/roomsTable/RoomsTable";
import RoomsFilter from "../../components/roomsTable/RoomsFilter";
import axios from "axios";
import {Link} from "react-router-dom";
import AxiosRequest from "../../helpers/AxiosRequest";
import RoomBan from "../../components/usersTable/roomBan";

const RoomsPage = (props) => {
// data state to store the TV Maze API data. Its initial value is an empty array
    const [rooms, setRooms] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10});
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            render: text => <Link to={{
                pathname: `/${props.match.params.imba_id}/room/${text}`
            }}>{text}</Link>,
        },
        {
            title: 'Pipe',
            dataIndex: 'pipe',
            key: 'pipe',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <div>
                    <RoomBan record={record} imba_id={props.match.params.imba_id}/>
                </div>
            )
        }

    ];

    function onChangePage(page, size) {
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
        })
    }

    // Using useEffect to call the API once mounted and set the data
    useEffect(() => {
        (async () => {
            AxiosRequest("imba_rooms_get", filters)
                .then((data) => {
                    setRooms(data.data)
                    setTotal(data.total)
                    setPer(data.per_page)
                })
                .catch((error) =>{
                    window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, [filters]);

    const onChangeFilter = (values) => {
        values.imba_id = props.match.params.imba_id;
        values.per_page = per;
        setFilters(values)

    }
    return (
        <div className="App">
            <RoomsFilter onChange={onChangeFilter}/>
            <RoomsTable imba_id={props.match.params.imba_id} dataSource={rooms} columns={columns } total={total} per={per} />
            <Pagination
                showSizeChanger
                className={'table-pagination'}
                onShowSizeChange={onChangeSize}
                defaultCurrent={1}
                PageSize={per}
                total={total}
                onChange={onChangePage}
            />
        </div>

    );
}

export default RoomsPage;